import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useHistory, Link, useParams } from 'react-router-dom';
import { Breadcrumb, message } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import fp from 'lodash/fp';
import moment from 'moment';
import { useLoading } from 'hooks';
import Form from './components/Form';
import {
  EDIT_PROJECT_APPLICATION_SETTING,
  GET_PROJECT_APPLICATION_SETTING,
  GET_PROJECT_APPLICATION_SETTINGS,
} from 'gql/projectApplicationSetting';

const getTeamMemberMapping = fp.pipe([
  fp.get('teamMemberMapping'),
  fp.map(({ name, teamMemberType }) => ({
    name,
    teamMemberType: teamMemberType.id,
  })),
]);
const getRoleHierarchy = fp.map(({ sequence, level, role }) => ({
  sequence,
  level,
  role: role.id,
}));

const EditProjectApplicationSetting = () => {
  const { id } = useParams();
  const history = useHistory();
  const [edit, { loading }] = useMutation(EDIT_PROJECT_APPLICATION_SETTING, {
    refetchQueries: [
      {
        query: GET_PROJECT_APPLICATION_SETTINGS,
        variables: { state: 'ALL' },
      },
    ],
    onCompleted: ({ updateProjectApplicationSetting }) => {
      history.push('/system-setting/project-application-settings');
      message.success(
        `Funding Application Setting ${updateProjectApplicationSetting.title} successfully edited`
      );
    },
    onError: (err) => {
      console.log(err);
    },
  });
  const { data, loading: queryLoading } = useQuery(
    GET_PROJECT_APPLICATION_SETTING,
    { variables: { id: id } }
  );
  useLoading(loading);

  const onFinish = (input) => {
    edit({
      variables: {
        input: {
          id,
          code: input.code,
          title: input.title,
          startDate: moment(input.date[0]).format('YYYY-MM-DD'),
          endDate: moment(input.date[1]).format('YYYY-MM-DD'),
          description: input.description,
          teamMemberMapping: input.teamMemberMapping,
          roleHierarchy: input.roleHierarchy,
          approvedFundingSource: input.approvedFundingSource,
          additionalFundingSource: input.additionalFundingSource,
          deadlineOfUsingUpFunding: moment(
            input.deadlineOfUsingUpFunding
          ).format('YYYY-MM-DD'),
          disabled: !input.active,
        },
      },
    });
  };
  const teamMemberMapping = getTeamMemberMapping(
    data?.projectApplicationSetting
  );
  const initialValues = data?.projectApplicationSetting
    ? {
        title: data.projectApplicationSetting.title,
        teamMemberMapping,
        code: data.projectApplicationSetting.code,
        roleHierarchy: {
          department: getRoleHierarchy(
            data.projectApplicationSetting.roleHierarchy.department
          ),
          faculty: getRoleHierarchy(
            data.projectApplicationSetting.roleHierarchy.faculty
          ),
          school: getRoleHierarchy(
            data.projectApplicationSetting.roleHierarchy.school
          ),
          NAU: getRoleHierarchy(
            data.projectApplicationSetting.roleHierarchy.NAU
          ),
        },
        date: [
          moment(data.projectApplicationSetting.startDate),
          moment(data.projectApplicationSetting.endDate),
        ],
        deadlineOfUsingUpFunding:
          data.projectApplicationSetting.deadlineOfUsingUpFunding,
        description: data.projectApplicationSetting.description,
        active: !data.projectApplicationSetting.disabled,
        approvedFundingSource:
          data.projectApplicationSetting?.approvedFundingSource?.id,
        additionalFundingSource:
          data.projectApplicationSetting?.additionalFundingSource?.id,
      }
    : {};
  return (
    <PageContainer
      header={{
        title: 'Edit Funding Application Setting',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/project-application-settings">
                Funding Application Settings
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {data?.projectApplicationSetting?.title ||
                `Edit Funding Application Settings`}
            </Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
      loading={queryLoading}
    >
      <Form onFinish={onFinish} initialValues={initialValues} isEdit={true} />
    </PageContainer>
  );
};

EditProjectApplicationSetting.propTypes = {};

export default EditProjectApplicationSetting;
